import type { IntlShape } from '@cmg/i18n';

import type { InternalDemandSummary_MdlIndicationPartsFragment } from './graphql';

/**
 * Format indication preface based on its value type
 */
export const formatPreface = (
  indication: InternalDemandSummary_MdlIndicationPartsFragment,
  intl: IntlShape
) => {
  const isDollars = indication && !!indication.realDemandDollars;
  const isShares = indication && !!indication.realDemandShares;
  const isPercentage = indication && !!indication.realDemandPercentage;

  if (isDollars) {
    return intl.formatNumber(indication.realDemandDollars, { format: 'currency' });
  }

  if (isShares) {
    return `${intl.formatNumber(indication.realDemandShares, { format: 'integer' })} Shares`;
  }

  if (isPercentage) {
    return intl.formatNumber(indication.realDemandPercentage, {
      format: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  return '';
};
